import api from "./Api";

class ClienteService {
  GetCliente(payload) {
    return api.get("/v1/cliente/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCliente(payload) {
    return api.post("/v1/cliente/", payload).then((response) => {
      return response.data;
    });
  }

  PutCliente(payload) {
    return api.put("/v1/cliente/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCliente(payload) {
    return api.delete("/v1/cliente/" + payload).then((response) => {
      return response.data;
    });
  }

  GetClienteOData(payload) {
    return api.get("/OData/Cliente" + payload).then((response) => {
      return response.data;
    });
  }

  Validate(payload) {
    return api.post("/v1/cliente/Validate/", payload).then((response) => {
      return response.data;
    });
  }

  Converter(payload) {
    return api.post("/v1/cliente/Converter/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new ClienteService();
